import * as React from "react";
import { cx } from "../util.js";

export interface NavItemProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  /** Active/selected state. */
  active?: boolean;
  /** Leading icon. */
  icon?: React.ReactNode;
}
/** Sidebar navigation item. */
export function NavItem({ active, icon, className, children, ...rest }: NavItemProps) {
  return (
    <button
      type="button"
      className={cx("ip-nav-item", className)}
      data-active={active ? "true" : undefined}
      aria-current={active ? "page" : undefined}
      {...rest}
    >
      {icon}
      {children}
    </button>
  );
}

export interface SidebarNavProps extends React.HTMLAttributes<HTMLElement> {}
/** Vertical container for NavItems. */
export function SidebarNav({ className, ...rest }: SidebarNavProps) {
  return <nav className={cx("ip-nav", className)} {...rest} />;
}
